import React from 'react';

function New(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M17.732 2.73243L9.77699 10.6874C9.68135 10.7831 9.61932 10.9072 9.6002 11.0411L9.15854 14.1352C9.09966 14.5477 9.45328 14.9012 9.86577 14.8422L12.9591 14.3997C13.0929 14.3806 13.2169 14.3186 13.3125 14.223L21.2675 6.26798C22.2441 5.29141 22.2441 3.70901 21.2675 2.73243C20.291 1.75586 18.7086 1.75586 17.732 2.73243ZM20.4748 3.71786C20.8699 4.20885 20.8395 4.92824 20.3837 5.3841L12.5758 13.192L10.5138 13.486L10.8068 11.425L18.6159 3.61632C19.1043 3.12789 19.8952 3.12789 20.3837 3.61632L20.4748 3.71786ZM11.375 5C11.7202 5 12 5.27982 12 5.625C12 5.97018 11.7202 6.25 11.375 6.25H4.8C4.49624 6.25 4.25 6.49624 4.25 6.8V19.2C4.25 19.5038 4.49624 19.75 4.8 19.75H17.2C17.5038 19.75 17.75 19.5038 17.75 19.2V12.625C17.75 12.2798 18.0298 12 18.375 12C18.7202 12 19 12.2798 19 12.625V19.2C19 20.1941 18.1941 21 17.2 21H4.8C3.80589 21 3 20.1941 3 19.2V6.8C3 5.80589 3.80589 5 4.8 5H11.375Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default New;
